import type { ModelEntry } from './types';

export const genjutsuObjectSwap = {
  id: 'genjutsu-object-swap',
  surface: 'video',
  label: 'Genjutsu Object Swap',
  roles: { video: 1, reference: 8 },
  settings: {
    resolution: { type: 'enum', values: ['480p', '720p'], default: '720p' },
  },
} as const satisfies ModelEntry;
